import template from "./signature.html";
import SignaturePad from "signature_pad";
import _ from "lodash";
import en from "./en.json";
import es from "./es.json";

class SignatureController {
    /* @ngInject */
    constructor($window, $scope, $element) {
        this.$window = $window;
        this.$scope = $scope;
        this.$element = $element;
        this.resizeObserver = null;
        this.handleBeginStroke = null;
        this.handleEndStroke = null;
    }

    getSignatureValue() {
        let ctrl = this;
        let value = ctrl.signaturePad.toDataURL();
        if (ctrl.dsp) {
            value = value.split(",")[1];
        }
        return value;
    }

    clear() {
        let ctrl = this;
        ctrl.signaturePad.clear();
        ctrl.onUpdate({
            value: ctrl.getSignatureValue(),
            isEmpty: ctrl.signaturePad.isEmpty(),
        });
    }

    $onInit() {
        let ctrl = this;
        let canvas = ctrl.$element.find("canvas")[0];
        ctrl.signaturePad = new SignaturePad(canvas, {
            backgroundColor: "rgba(0,0,0,0)",
        });
        ctrl.handleBeginStroke = function () {
            ctrl.$scope.$applyAsync(function () {
                if (!ctrl.signaturePad.isEmpty()) {
                    ctrl.onStart({ value: ctrl.getSignatureValue() });
                }
            });
        };
        ctrl.signaturePad.addEventListener(
            "beginStroke",
            ctrl.handleBeginStroke,
        );

        ctrl.handleEndStroke = _.debounce(function () {
            ctrl.$scope.$applyAsync(function () {
                if (!ctrl.signaturePad.isEmpty()) {
                    ctrl.onUpdate({
                        value: ctrl.getSignatureValue(),
                        isEmpty: ctrl.signaturePad.isEmpty(),
                    });
                }
            });
        }, 500);
        ctrl.signaturePad.addEventListener("endStroke", ctrl.handleEndStroke);

        function renderSignature(dataUrl) {
            const img = new Image();
            img.onload = function () {
                const hRatio = canvas.offsetWidth / img.width;
                const vRatio = canvas.offsetHeight / img.height;
                const ratio = Math.min(hRatio, vRatio, 1);
                const imgWidth = img.width * ratio;
                const imgHeight = img.height * ratio;
                const xOffset = (canvas.offsetWidth - imgWidth) / 2;
                const yOffset = (canvas.offsetHeight - imgHeight) / 2;
                ctrl.signaturePad.fromDataURL(dataUrl, {
                    width: imgWidth,
                    height: imgHeight,
                    xOffset,
                    yOffset,
                });
                ctrl.$scope.$applyAsync();
            };
            img.src = dataUrl;
        }

        function resizeCanvas() {
            ctrl.$scope.$applyAsync(function () {
                let ratio = Math.max(ctrl.$window.devicePixelRatio || 1, 1);
                canvas.width = canvas.offsetWidth * ratio;
                canvas.height = canvas.offsetHeight * ratio;
                canvas.getContext("2d").scale(ratio, ratio);
                ctrl.signaturePad.redraw();
            });
        }

        ctrl.resizeObserver = new ResizeObserver(resizeCanvas);
        ctrl.resizeObserver.observe(canvas);

        resizeCanvas();
        if (ctrl.initialSignature) {
            let initialSignatureDataUrl = /^data:image\//.test(
                ctrl.initialSignature,
            )
                ? ctrl.initialSignature
                : "data:image/png;base64," + ctrl.initialSignature;
            renderSignature(initialSignatureDataUrl);
        }
    }

    $onDestroy() {
        let ctrl = this;
        if (ctrl.resizeObserver) {
            ctrl.resizeObserver.disconnect();
            ctrl.resizeObserver = null;
        }
        if (ctrl.handleEndStroke && ctrl.handleEndStroke.cancel) {
            ctrl.handleEndStroke.cancel();
        }
        if (ctrl.signaturePad && ctrl.handleBeginStroke) {
            ctrl.signaturePad.removeEventListener(
                "beginStroke",
                ctrl.handleBeginStroke,
            );
        }
        if (ctrl.signaturePad && ctrl.handleEndStroke) {
            ctrl.signaturePad.removeEventListener(
                "endStroke",
                ctrl.handleEndStroke,
            );
        }
        if (ctrl.signaturePad) {
            ctrl.signaturePad.off();
        }
    }
}

export default {
    controller: SignatureController,
    bindings: {
        onUpdate: "&",
        onStart: "&",
        initialSignature: "<",
        dsp: "<",
    },
    template,
    name: "signature",
    translations: { en, es },
};
